// Utility function to check if a value is not empty (null, undefined, empty string, or only whitespace)
export function isNotEmpty(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  if (Array.isArray(value) && value.length === 0) return false;
  if (typeof value === 'object' && !Array.isArray(value)) {
    // For objects, check if it has any keys
    return Object.keys(value).length > 0;
  }
  return !!value;
}

